import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Button from 'COMMON/button';
import { Input } from 'reactstrap';
import { saveClassified } from 'ACTIONS/create_classified/saveClassified';
import { showModalWithData } from 'ACTIONS/ui/showModalWithData';
import { MODALS } from 'MODULES/MODALS';

const PriceEditForm = ({ showEditPrice, editPrice, pp, price, i18n }) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(price[0]);
    const [initialValue, setInitialValue] = useState(price[0]);

    useEffect(() => {
        if (price[0] !== initialValue) {
            setValue(price[0]);
            setInitialValue(price[0]);
        }
    }, [price]);

    return (
        <>
            {editPrice && <Input type="number" className="edit-price" max="10000.00" step="0.01" autoFocus value={value} onChange={(e) => setValue(e.target.value)} />}
            {editPrice && (
                <>
                    <Button
                        icon="pp-close fs-1-5rem pe-0 pt-2"
                        btnOnlyIcon
                        disabled={!Number(value)}
                        secondary
                        onClick={() => {
                            showEditPrice(false);
                        }}
                    />
                    {value !== initialValue && value && (
                        <Button
                            icon="pp-save fs-1-5rem pt-2"
                            fontSet="pp-ico"
                            btnOnlyIcon
                            secondary
                            onClick={() => {
                                dispatch(saveClassified({ prices: { 1: { value } } }, pp.id, () => {
                                    showEditPrice(false);
                                }));
                            }}
                        />
                    )}
                </>
            )}
            {!editPrice && !pp.xmlImported && (
                <div
                    icon="pp-pencil fs-1-5rem"
                    className="btn-link ms-2"
                    onClick={() => {
                        dispatch(showModalWithData({ pp }, MODALS.priceEdit, true));
                    }}
                >
                    {i18n.__('Edit price')}
                </div>
            )}
        </>
    );
};


export default PriceEditForm;
